import type { SearchResponse } from '@algolia/client-search'
import type { RequestOptionsObject } from '@nuxtjs/algolia'
import { useAlgoliaSearchClient } from '~/composables/algolia/useAlgoliaSearchClient'

export type AlgoliaIndexSearchParams = {
  query: string
  requestOptions?: RequestOptionsObject
}

export type UseAlgoliaIndexSearchReturnType<T> = {
  result: ComputedRef<SearchResponse<T> | null>
  search: (params: AlgoliaIndexSearchParams) => Promise<SearchResponse<T>>
}

export const useAlgoliaIndexSearch = <T = Record<string, unknown>>(
  indexName: string
): UseAlgoliaIndexSearchReturnType<T> => {
  const result = useState<SearchResponse<T> | null>(
    `${indexName}-search-result`,
    () => null
  )

  const search = async ({
    query,
    requestOptions,
  }: AlgoliaIndexSearchParams) => {
    const algoliaIndex = useAlgoliaSearchClient().initIndex(indexName)
    const searchResult = await algoliaIndex.search(query, requestOptions)
    result.value = searchResult
    return searchResult
  }

  onUnmounted(() => {
    result.value = null
  })

  return {
    result: computed(() => result.value),
    search,
  }
}
